<template>
  <div>
 <span class="bread-crumb-title">{{titulo}}</span>
    <el-button v-if="backButton" class="bread-crumb-back-button" >Voltar</el-button>
    <el-breadcrumb separator="/" v-if="activeBreadcrumb">
      <el-breadcrumb-item class="bread-crumb-itens" :to="{ name:'Painel' }">Início</el-breadcrumb-item>
      <el-breadcrumb-item v-for="(item, index) in findMenuSelecionado(menus)" :key="index" class="bread-crumb-itens" :to="{ name:item.routerName }"> {{item.name}}
      </el-breadcrumb-item>
  </el-breadcrumb>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    titulo: String,
    activeBreadcrumb: {
      type: Boolean,
      default: true
    },
    backButton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState([
      'menus'
    ])
  },
  methods: {
    findMenuSelecionado (menus) {
      const routerName = this.$route.name
      let menuSelecionado = []
      for (let i = 0; i < menus.length; i++) {
        let menu = menus[i]
        if (menu.routerName === routerName) {
          menuSelecionado.push({ ...menu })
          break
        } else if (menu.childs && menu.childs.length) {
          const menuFilho = this.findMenuSelecionado(menu.childs)
          if (menuFilho.length > 0) {
            menuSelecionado.push({ ...menu })
            menuSelecionado = [ ...menuSelecionado, ...menuFilho ]
            break
          }
        }
      }
      return menuSelecionado
    }
  }
}
</script>
<style>

  .bread-crumb-itens {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 11px;
    letter-spacing: 0;
    color: #333333;
  }

  .el-breadcrumb__inner.is-link {
    font-weight: 400;
  }

  .bread-crumb-title {
    text-align: left;
    font-size: 24px;
    font-family: Arial, sans-serif;
    letter-spacing: 0;
    color: #000000;
    font-weight: 700;
  }

  .el-breadcrumb__item:last-child .el-breadcrumb__inner, .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover, .el-breadcrumb__item:last-child .el-breadcrumb__inner a, .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover {
    cursor: pointer !important;
  }

  .el-breadcrumb {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .bread-crumb-back-button {
    font-size: 12px;
    font-family: Arial, sans-serif;
    letter-spacing: 0;
    color: #0075EA;
    font-weight: 600;
    background-color: #ffffff;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    outline: none;
    padding: 12px 20px;
    text-align: center;
    text-decoration: none;
    display: inline;
    transition-duration: 0.4s;
    user-select: none;
    float: right;
  }

</style>
